module.exports = __webpack_public_path__ + "static/media/Adi.b3977f98.png";